// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var TakeawayIsSymbol = {
    reflectSymbol: function () {
        return "Takeaway";
    }
};
var UberIsSymbol = {
    reflectSymbol: function () {
        return "Uber";
    }
};
var GlovoIsSymbol = {
    reflectSymbol: function () {
        return "Glovo";
    }
};
var WoltIsSymbol = {
    reflectSymbol: function () {
        return "Wolt";
    }
};
var OnlineIsSymbol = {
    reflectSymbol: function () {
        return "Online";
    }
};
var PhoneIsSymbol = {
    reflectSymbol: function () {
        return "Phone";
    }
};
var BarIsSymbol = {
    reflectSymbol: function () {
        return "Bar";
    }
};
var QrWaiterIsSymbol = {
    reflectSymbol: function () {
        return "QrWaiter";
    }
};
var PortalIsSymbol = {
    reflectSymbol: function () {
        return "Portal";
    }
};
var OtherIsSymbol = {
    reflectSymbol: function () {
        return "Other";
    }
};
var PyszneIsSymbol = {
    reflectSymbol: function () {
        return "Pyszne";
    }
};
var PizzaPortalIsSymbol = {
    reflectSymbol: function () {
        return "PizzaPortal";
    }
};
var CustomIsSymbol = {
    reflectSymbol: function () {
        return "Custom";
    }
};
var externalOrderOriginIsSymbol = {
    reflectSymbol: function () {
        return "externalOrderOrigin";
    }
};
var integratorNameIsSymbol = {
    reflectSymbol: function () {
        return "integratorName";
    }
};
var ExternalIntegrationIsSymbol = {
    reflectSymbol: function () {
        return "ExternalIntegration";
    }
};
var AndroidAppIsSymbol = {
    reflectSymbol: function () {
        return "AndroidApp";
    }
};
var IosAppIsSymbol = {
    reflectSymbol: function () {
        return "IosApp";
    }
};
var ApetiloIsSymbol = {
    reflectSymbol: function () {
        return "Apetilo";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor);
var genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)));
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var Takeaway = /* #__PURE__ */ (function () {
    function Takeaway() {

    };
    Takeaway.value = new Takeaway();
    return Takeaway;
})();
var Uber = /* #__PURE__ */ (function () {
    function Uber() {

    };
    Uber.value = new Uber();
    return Uber;
})();
var Glovo = /* #__PURE__ */ (function () {
    function Glovo() {

    };
    Glovo.value = new Glovo();
    return Glovo;
})();
var Wolt = /* #__PURE__ */ (function () {
    function Wolt() {

    };
    Wolt.value = new Wolt();
    return Wolt;
})();
var Online = /* #__PURE__ */ (function () {
    function Online() {

    };
    Online.value = new Online();
    return Online;
})();
var Phone = /* #__PURE__ */ (function () {
    function Phone() {

    };
    Phone.value = new Phone();
    return Phone;
})();
var Bar = /* #__PURE__ */ (function () {
    function Bar() {

    };
    Bar.value = new Bar();
    return Bar;
})();
var QrWaiter = /* #__PURE__ */ (function () {
    function QrWaiter() {

    };
    QrWaiter.value = new QrWaiter();
    return QrWaiter;
})();
var Portal = /* #__PURE__ */ (function () {
    function Portal() {

    };
    Portal.value = new Portal();
    return Portal;
})();
var Other = /* #__PURE__ */ (function () {
    function Other() {

    };
    Other.value = new Other();
    return Other;
})();
var Pyszne = /* #__PURE__ */ (function () {
    function Pyszne() {

    };
    Pyszne.value = new Pyszne();
    return Pyszne;
})();
var PizzaPortal = /* #__PURE__ */ (function () {
    function PizzaPortal() {

    };
    PizzaPortal.value = new PizzaPortal();
    return PizzaPortal;
})();
var Custom = /* #__PURE__ */ (function () {
    function Custom(value0) {
        this.value0 = value0;
    };
    Custom.create = function (value0) {
        return new Custom(value0);
    };
    return Custom;
})();
var ExternalIntegration = /* #__PURE__ */ (function () {
    function ExternalIntegration(value0) {
        this.value0 = value0;
    };
    ExternalIntegration.create = function (value0) {
        return new ExternalIntegration(value0);
    };
    return ExternalIntegration;
})();
var AndroidApp = /* #__PURE__ */ (function () {
    function AndroidApp() {

    };
    AndroidApp.value = new AndroidApp();
    return AndroidApp;
})();
var IosApp = /* #__PURE__ */ (function () {
    function IosApp() {

    };
    IosApp.value = new IosApp();
    return IosApp;
})();
var Apetilo = /* #__PURE__ */ (function () {
    function Apetilo() {

    };
    Apetilo.value = new Apetilo();
    return Apetilo;
})();
var toFillFormTypeOrderOrigin = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqExternalOrderOrigin = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Takeaway && y instanceof Takeaway) {
                return true;
            };
            if (x instanceof Uber && y instanceof Uber) {
                return true;
            };
            if (x instanceof Glovo && y instanceof Glovo) {
                return true;
            };
            if (x instanceof Wolt && y instanceof Wolt) {
                return true;
            };
            return false;
        };
    }
};
var eq1 = /* #__PURE__ */ Data_Eq.eq(eqExternalOrderOrigin);
var eqOrderOrigin = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Online && y instanceof Online) {
                return true;
            };
            if (x instanceof Phone && y instanceof Phone) {
                return true;
            };
            if (x instanceof Bar && y instanceof Bar) {
                return true;
            };
            if (x instanceof QrWaiter && y instanceof QrWaiter) {
                return true;
            };
            if (x instanceof Portal && y instanceof Portal) {
                return true;
            };
            if (x instanceof Other && y instanceof Other) {
                return true;
            };
            if (x instanceof Pyszne && y instanceof Pyszne) {
                return true;
            };
            if (x instanceof PizzaPortal && y instanceof PizzaPortal) {
                return true;
            };
            if (x instanceof Custom && y instanceof Custom) {
                return x.value0 === y.value0;
            };
            if (x instanceof ExternalIntegration && y instanceof ExternalIntegration) {
                return eq1(x.value0.externalOrderOrigin)(y.value0.externalOrderOrigin) && x.value0.integratorName === y.value0.integratorName;
            };
            if (x instanceof AndroidApp && y instanceof AndroidApp) {
                return true;
            };
            if (x instanceof IosApp && y instanceof IosApp) {
                return true;
            };
            if (x instanceof Apetilo && y instanceof Apetilo) {
                return true;
            };
            return false;
        };
    }
};
var ordExternalOrderOrigin = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Takeaway && y instanceof Takeaway) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Takeaway) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Takeaway) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Uber && y instanceof Uber) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Uber) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Uber) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Glovo && y instanceof Glovo) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Glovo) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Glovo) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Wolt && y instanceof Wolt) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqExternalOrderOrigin;
    }
};
var compare1 = /* #__PURE__ */ Data_Ord.compare(ordExternalOrderOrigin);
var ordOrderOrigin = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Online && y instanceof Online) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Online) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Online) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Phone && y instanceof Phone) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Phone) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Phone) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Bar && y instanceof Bar) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Bar) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Bar) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof QrWaiter && y instanceof QrWaiter) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof QrWaiter) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof QrWaiter) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Portal && y instanceof Portal) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Portal) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Portal) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Other && y instanceof Other) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Other) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Other) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Pyszne && y instanceof Pyszne) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Pyszne) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Pyszne) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof PizzaPortal && y instanceof PizzaPortal) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof PizzaPortal) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof PizzaPortal) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Custom && y instanceof Custom) {
                return compare(x.value0)(y.value0);
            };
            if (x instanceof Custom) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Custom) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ExternalIntegration && y instanceof ExternalIntegration) {
                var v = compare1(x.value0.externalOrderOrigin)(y.value0.externalOrderOrigin);
                if (v instanceof Data_Ordering.LT) {
                    return Data_Ordering.LT.value;
                };
                if (v instanceof Data_Ordering.GT) {
                    return Data_Ordering.GT.value;
                };
                return compare(x.value0.integratorName)(y.value0.integratorName);
            };
            if (x instanceof ExternalIntegration) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ExternalIntegration) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof AndroidApp && y instanceof AndroidApp) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof AndroidApp) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof AndroidApp) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof IosApp && y instanceof IosApp) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof IosApp) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof IosApp) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Apetilo && y instanceof Apetilo) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqOrderOrigin;
    }
};
var genericOrderOrigin = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Online.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Phone.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Bar.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return QrWaiter.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return Portal.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return Other.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return Pyszne.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return PizzaPortal.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new Custom(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return new ExternalIntegration(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return AndroidApp.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return IosApp.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))) {
            return Apetilo.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 18, column 1 - line 18, column 77): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Online) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Phone) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Bar) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof QrWaiter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Portal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof Other) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof Pyszne) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof PizzaPortal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof Custom) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof ExternalIntegration) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
        };
        if (x instanceof AndroidApp) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof IosApp) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof Apetilo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 18, column 1 - line 18, column 77): " + [ x.constructor.name ]);
    }
};
var genericExternalOrderOrigin = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Takeaway.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Uber.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Glovo.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return Wolt.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 54, column 1 - line 54, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Takeaway) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Uber) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Glovo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Wolt) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.OrderOrigin (line 54, column 1 - line 54, column 93): " + [ x.constructor.name ]);
    }
};
var showExternalOrderOrigin = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericExternalOrderOrigin)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(TakeawayIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(UberIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(GlovoIsSymbol))(/* #__PURE__ */ genericShowConstructor(WoltIsSymbol)))))
};
var showOrderOrigin = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderOrigin)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(OnlineIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PhoneIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(BarIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(QrWaiterIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PortalIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(OtherIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PyszneIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PizzaPortalIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))(CustomIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(externalOrderOriginIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(integratorNameIsSymbol)(Data_Show.showString))(showExternalOrderOrigin))))(ExternalIntegrationIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(AndroidAppIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(IosAppIsSymbol))(/* #__PURE__ */ genericShowConstructor(ApetiloIsSymbol))))))))))))))
};
var unscrambleDecodeExternalOrderOrigin = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericExternalOrderOrigin)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(TakeawayIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(UberIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(GlovoIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(WoltIsSymbol)))))(Unscramble_Enum.defaultEnumOptions)
};
var unscrambleDecodeOrderOrigin = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderOrigin)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(OnlineIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(PhoneIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(BarIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(QrWaiterIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(PortalIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(OtherIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(PyszneIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(PizzaPortalIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(CustomIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeString1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ExternalIntegrationIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons(externalOrderOriginIsSymbol)(unscrambleDecodeExternalOrderOrigin)(/* #__PURE__ */ Unscramble.decodeRecordCons(integratorNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(AndroidAppIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(IosAppIsSymbol))(/* #__PURE__ */ genericDecodeSumConstruct1(ApetiloIsSymbol)))))))))))))))(Unscramble_Generic.defaultOptions)
};
var boundedExternalOrderOrigi = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericExternalOrderOrigin)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor)))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericExternalOrderOrigin)(genericBottomSum),
    Ord0: function () {
        return ordExternalOrderOrigin;
    }
};
var enumExternalOrderOrigin = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericExternalOrderOrigin)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericExternalOrderOrigin)(genericEnumSum1),
    Ord0: function () {
        return ordExternalOrderOrigin;
    }
};
var boundedEnumExternalOrderO = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericExternalOrderOrigin)(genericBoundedEnumSum1),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericExternalOrderOrigin)(genericBoundedEnumSum1),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericExternalOrderOrigin)(genericBoundedEnumSum1),
    Bounded0: function () {
        return boundedExternalOrderOrigi;
    },
    Enum1: function () {
        return enumExternalOrderOrigin;
    }
};
var toFillFormTypeExternalOrd = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericExternalOrderOrigin)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(TakeawayIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(UberIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(GlovoIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(WoltIsSymbol)))))
};
var encodeExternalOrderOrigin = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericExternalOrderOrigin)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(UberIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(GlovoIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(WoltIsSymbol)))))
};
var encodeOrderOrigin = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericOrderOrigin)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OnlineIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PhoneIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(BarIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(QrWaiterIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PortalIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OtherIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PyszneIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PizzaPortalIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CustomIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(encodeWithOptionsOther)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ExternalIntegrationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(integratorNameIsSymbol)(encodeWithOptionsOther))(externalOrderOriginIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeExternalOrderOrigin))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(AndroidAppIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(IosAppIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ApetiloIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))))))))))))))
};
var decodeExternalOrderOrigin = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericExternalOrderOrigin)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(UberIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(GlovoIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(WoltIsSymbol)))))
};
var decodeOrderOrigin = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericOrderOrigin)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OnlineIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PhoneIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(BarIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(QrWaiterIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PortalIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OtherIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PyszneIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PizzaPortalIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CustomIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(decodeWithOptionsOther))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ExternalIntegrationIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(integratorNameIsSymbol)(decodeWithOptionsOther)())(externalOrderOriginIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeExternalOrderOrigin))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(AndroidAppIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(IosAppIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ApetiloIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))))))))))))
};
export {
    Online,
    Phone,
    Bar,
    QrWaiter,
    Portal,
    Other,
    Pyszne,
    PizzaPortal,
    Custom,
    ExternalIntegration,
    AndroidApp,
    IosApp,
    Apetilo,
    Takeaway,
    Uber,
    Glovo,
    Wolt,
    genericOrderOrigin,
    eqOrderOrigin,
    showOrderOrigin,
    ordOrderOrigin,
    encodeOrderOrigin,
    decodeOrderOrigin,
    unscrambleDecodeOrderOrigin,
    toFillFormTypeOrderOrigin,
    genericExternalOrderOrigin,
    eqExternalOrderOrigin,
    showExternalOrderOrigin,
    encodeExternalOrderOrigin,
    decodeExternalOrderOrigin,
    unscrambleDecodeExternalOrderOrigin,
    ordExternalOrderOrigin,
    enumExternalOrderOrigin,
    boundedExternalOrderOrigi,
    boundedEnumExternalOrderO,
    toFillFormTypeExternalOrd
};
